import { TenantMembership } from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/TenantMembership";

// Resolves which membership to switch to for a `tenantExternalId` coming from a deeplink/query param.
// Returns null (no switch) when there is nothing to do or when the id does not belong to the user —
// a non-matching id (manipulated link or a conversation in another workspace) must never blow up the
// workspace state; it simply degrades to the currently selected tenant.
export function resolveTenantToSelect(
  tenantExternalId: string | null | undefined,
  currentTenantExternalId: string | undefined,
  memberships: TenantMembership[]
): TenantMembership | null {
  if (!tenantExternalId || tenantExternalId === currentTenantExternalId) {
    return null;
  }
  return memberships.find((tm) => tm.tenant?.externalId === tenantExternalId) ?? null;
}
